import React, { useEffect } from "react";
import styled from "styled-components";
import { AI_USAGE } from "../../utils/constants/labels";
import PageHeader from "../common/layout/PageHeader";
import { aiApi } from "../../api/aiApi";
import colors from "../../utils/colors";
import { StyledAntTable } from "../common/table/Table.style";
import { AiDailyUsage } from "../../types/aiTypes";
import { DATE_FORMAT, formatDate } from "../../utils/timeUtils";
import { DatePreview } from "../../utils/helpers";
import Button from "../common/buttons/Button";

const ITEMS_PER_PAGE = 20;

const columns = () => [
  {
    title: 'UserID',
    dataIndex: 'user_id',
    width: '5%',
  },
  {
    title: 'Day',
    dataIndex: 'date',
    width: '10%',
    render: value => (value ? <DatePreview>{formatDate(value, DATE_FORMAT)}</DatePreview> : null)
  },
  {
    title: 'Last Updated',
    dataIndex: 'last_updated',
    width: '10%',
    render: value => (value ? <DatePreview>{formatDate(value, 'hh:mm a')}</DatePreview> : null)
  },
  {
    title: 'Tokens (i + o)',
    dataIndex: 'tokens',
    width: '10%',
    render: (value, row) => {
      return <span>{row['input_tokens']} + {row['output_tokens']}</span>;
    }
  },
  {
    title: 'Tokens (t)',
    dataIndex: 'tokens',
    width: '10%',
    render: (value, row) => {
      return <span>{row['total_tokens']}</span>;
    }
  },
];

const AiUsage = () => {
  const [data, setData] = React.useState<AiDailyUsage[]>();
  const [cursor, setCursor] = React.useState<string>();
  const [loadingMore, setLoadingMore] = React.useState<boolean>(false);

  useEffect(() => {
    const init = async () => {
      const res = await aiApi.getAiUsage(ITEMS_PER_PAGE);
      if (res.ok) {
        setData(res.data?.items);
        setCursor(res.data?.cursor);
      }
    }

    init();
  }, []);

  const loadMore = async () => {
    setLoadingMore(true);
    const res = await aiApi.getAiUsage(ITEMS_PER_PAGE, cursor);
    if (res.ok) {
      setData(prev => [...(prev || []), ...(res.data?.items || [])]);
      setCursor(res.data?.cursor);
      setLoadingMore(false);
    }
  }

  return (
    <Container>
      <PageHeader
        title={AI_USAGE}
      />
      <StyledAntTable
        columns={columns()}
        rowKey={record => `${record['user_id']}-${record['date']}`}
        dataSource={data ?? []}
        pagination={false}
      />
      <LoadMoreWrapper>
        {cursor && (
          <Button onClick={loadMore} loading={loadingMore}>
            Load More
          </Button>
        )}
      </LoadMoreWrapper>
    </Container>
  );
}

export default AiUsage;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex: 1;
  background-color: ${colors.white};
  position: relative;
`;

const LoadMoreWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px 0;
`;